import app from 'flarum/forum/app';

/**
 * Slug canonico de la categoria del grupo cerrado. Es la misma en produccion y en el
 * staging local (seed del runbook §8.7). Vive aqui para que nav y D7 no la escriban dos
 * veces con riesgo de divergir.
 */
export const N8N_TAG_SLUG = 'n8n-chile';

/**
 * Slug de la categoria de encuentros (Spec §11: «Encuentros» es la palabra oficial).
 */
export const MEETUPS_TAG_SLUG = 'encuentros';

/**
 * Ruta actual, normalizada y sin query ni hash.
 *
 * Se prefiere `m.route.get()` sobre `location.pathname` porque ya viene relativo al
 * basePath del foro y mithril lo actualiza antes del redraw. Antes del primer render del
 * router (`m.route` aun sin inicializar) cae a `location.pathname`.
 */
export function currentPath(): string {
  let path = '';

  try {
    path = m.route.get() || '';
  } catch (e) {
    path = '';
  }

  if (!path) path = window.location.pathname || '/';

  return path.split('?')[0].split('#')[0] || '/';
}

/**
 * ¿La sesion actual ve la categoria del grupo cerrado?
 *
 * Se mira la visibilidad EFECTIVA de la etiqueta, no el nombre del grupo ni un permiso
 * concreto: `n8n-chile` es `is_restricted`, asi que solo viaja en el payload de quien puede
 * verla. Es la misma condicion que decide si `/t/n8n-chile` le responde 200 o 404, que es
 * justo lo que el nav necesita saber para no mandar a nadie a un 404 (checklist 22).
 *
 * OJO si algun dia se cambia por una comprobacion de permisos: el que gobierna la
 * visibilidad es `tagN.viewForum`, NO `tagN.discussion.view`. `Access\ScopeTagVisibility`
 * llama a `Tag::whereHasPermission($actor, 'viewForum')`, y el filtro de `Tag.php` exige que
 * el string del permiso CONTENGA `viewForum` — `tagN.discussion.view` no lo contiene, de ahi
 * que el seed original dejara al grupo ciego a su propia categoria (runbook §13.5).
 */
export function seesN8nTag(): boolean {
  return app.store.all<any>('tags').some((tag: any) => tag.slug() === N8N_TAG_SLUG);
}

/**
 * ¿La sesion actual tiene el correo confirmado?
 *
 * Vive aqui —junto a `seesN8nTag()`— porque es la otra sonda de estado de sesion que mas de
 * una pantalla necesita: `ProponerPage` la tenia como metodo privado y `SolicitudPage` la
 * necesita igual desde PKG-FORO-PRODUCT-GATES (decision D). Dos copias de la misma regla es
 * exactamente como se separan.
 *
 * SIN SESION DEVUELVE `false`, y no es un detalle: quien llama debe haber descartado antes al
 * invitado (esa persona tiene su propio estado, «entra primero»); si aun asi llega aqui, lo
 * honesto es «no confirmado» y no un `undefined` que reviente al leer `isEmailConfirmed`.
 *
 * FAIL-OPEN DELIBERADO CON SESION: `isEmailConfirmed` solo viaja en el payload para uno mismo
 * y para el admin (`UserSerializer` del core). Si por lo que sea no llegara, se asume que SI —
 * mejor dejar enviar y que el servidor decida (que es el unico que manda) que bloquear en
 * pantalla a quien si podia. El 409 `umbral_email_unconfirmed` es la red que recoge ese caso,
 * y desde este paquete ya no cae en la alerta generica de Flarum.
 */
export function emailConfirmed(): boolean {
  const user: any = app.session.user;

  if (!user) return false;

  return typeof user.isEmailConfirmed !== 'function' || user.isEmailConfirmed();
}
